// extracted by mini-css-extract-plugin
export default {"content":"RuleContent_content__z-iqN","smart":"RuleContent_smart__2Mq3N","description":"RuleContent_description__b6QPC","number":"RuleContent_number__zCvu4"};